import React from 'react';
import PropTypes from 'prop-types';
import './styles/rating-badge.css';

/**
 * An enhanced badge for displaying ratings with color coding and icons
 * @param {number} rating - Rating value (0-3)
 * @param {string} prefix - Optional prefix text (e.g., "Design", "Exec")
 */
export default function RatingBadge({ rating, prefix }) {
  if (rating == null) return null;
  
  const labels = ['Pass', 'Consider', 'Recommend', 'Highly Recommend'];
  const icons = ['❌', '⚠️', '👍', '✅'];
  
  const idx = Math.max(0, Math.min(3, rating));
  
  return (
    <span className={`rating-badge rating-${idx}`}>
      {prefix && <span className="rating-prefix">{prefix}</span>}
      {labels[idx]} {icons[idx]}
    </span>
  );
}

RatingBadge.propTypes = { 
  rating: PropTypes.number, 
  prefix: PropTypes.string 
};